import {toast} from 'react-toastify';
import {useLocation} from 'react-router-dom';
import {VerdocsEndpoint} from '@verdocs/js-sdk';
import React, {FC, FormEvent, useState} from 'react';
import {InfoLinks} from './InfoLinks';

export const OAuth2Authorize: FC = () => {
  const {search} = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const params = new URLSearchParams(search);
  const client_id = params.get('client_id') || '';
  const redirect_uri = params.get('redirect_uri') || '';
  const state = params.get('state') || '';
  const scope = params.get('scope') || '';

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await VerdocsEndpoint.getDefault().api.post('/oauth2/authorize', {
        client_id,
        redirect_uri,
        response_type: 'code',
        state,
        scope,
        username,
        password,
      });

      window.location.href = response.data.redirect_url;
    } catch (err: any) {
      const message = err?.response?.data?.error || err?.message || 'Authentication failed';
      toast.error(message);
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-1 flex-row w-full pt-8 tablet:pt-16 justify-center overflow-y-scroll bg-[#4c56cb]">
      <div className="flex w-[451px] flex-col items-center">
        <div className="bg-white rounded-lg shadow-lg p-10 w-full max-w-[400px]">
          <div className="text-center mb-2">
            <img src="/logo192.png" alt="Verdocs Logo" className="w-16 h-16 mx-auto mb-4" />
            <h1 className="text-xl font-semibold text-gray-900 mb-1">Sign in to Verdocs</h1>
            <p className="text-sm text-gray-500">An application is requesting access to your account.</p>
          </div>

          <form onSubmit={handleSubmit} className="mt-6">
            <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              id="username"
              type="email"
              required
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#4c56cb]/30 focus:border-[#4c56cb] mb-4"
            />

            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#4c56cb]/30 focus:border-[#4c56cb] mb-6"
            />

            <button
              type="submit"
              disabled={submitting}
              className="w-full py-3 bg-[#4c56cb] text-white rounded-md text-sm font-semibold hover:bg-[#434790] disabled:opacity-50 disabled:cursor-not-allowed">
              {submitting ? 'Signing in...' : 'Sign in and authorize'}
            </button>
          </form>
        </div>

        <InfoLinks />
      </div>
    </div>
  );
};
